"use client";var e="@sainsburys-tech/fable",s="3.54.6";export{e as name,s as version};
